import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay, tap } from 'rxjs';
import { DashboardApiResponse} from '../models/admin-dashboard.model';
import { CreateOrganizationModel } from '../models/create-organization.model';
import { ScheduleExamRequest,ExamScheduleResponse} from '../models/Organization/scheduled-exam.model';
import { environment }  from '../../../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  private readonly apiUrl =
    `${environment.apiUrl}/Organization`;

private organizationsCache$:
  Observable<CreateOrganizationModel[]> | null = null;

  constructor(private http: HttpClient) {}

  // GET ALL - Cached
getOrganizations(): Observable<CreateOrganizationModel[]> {

  if (!this.organizationsCache$) {

    this.organizationsCache$ =
      this.http.get<CreateOrganizationModel[]>(
        `${this.apiUrl}/get-all-organizations`
      ).pipe(
        shareReplay(1)
      );
  }

  return this.organizationsCache$;
}
  // Clear cache when required
  clearOrganizationsCache(): void {
    this.organizationsCache$ = null;
  }

  // GET BY ID
  getOrganizationById(
    organizationId: number
  ): Observable<CreateOrganizationModel> {

    return this.http.get<CreateOrganizationModel>(
      `${this.apiUrl}/get-organization/${organizationId}`
    );
  }

  // CREATE
  createOrganization(
    form: CreateOrganizationModel
  ): Observable<CreateOrganizationModel> {

    return this.http.post<CreateOrganizationModel>(
      `${this.apiUrl}/create-organization`,
      form
    ).pipe(
      tap(() => this.clearOrganizationsCache())
    );
  }

  // UPDATE
  updateOrganization(
    organization: CreateOrganizationModel
  ): Observable<CreateOrganizationModel> {

    return this.http.put<CreateOrganizationModel>(
      `${this.apiUrl}/update-organization/${organization.organizationId}`,
      organization
    ).pipe(
      tap(() => this.clearOrganizationsCache())
    );
  }

  // UPDATE STATUS
  updateStatus(
    organizationId: number,
    isActive: boolean
  ): Observable<CreateOrganizationModel> {

    return this.http.put<CreateOrganizationModel>(
      `${this.apiUrl}/update-organization/${organizationId}`,
      {
        organizationId,
        isActive
      }
    ).pipe(
      tap(() => this.clearOrganizationsCache())
    );
  }

    createExamSchedule(
    request: ScheduleExamRequest
  ):
    Observable<ExamScheduleResponse> {

    return this.http.post<ExamScheduleResponse>(
      `${this.apiUrl}/create-exam-schedule`,
      request
    );
  }


 getAllExamSchedules(): Observable<ExamScheduleResponse[]> {
  return this.http.get<ExamScheduleResponse[]>(
    `${this.apiUrl}/get-all-exam-schedules`
  ).pipe(
    tap(response => console.log('Exam schedules response:', response))
  );
}


  getExamScheduleById(
    examScheduleId: number
  ):
    Observable<ExamScheduleResponse> {

    return this.http.get<ExamScheduleResponse>(
      `${this.apiUrl}/get-exam-schedule/${examScheduleId}`
    );
  }

  getSummary(): Observable<DashboardApiResponse> {
    return this.http.get<DashboardApiResponse>(
      `${this.apiUrl}/summary`
    );
  }
}
